import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { ChatStackParamList } from "../types";
import ChatHubScreen from "./chat/ChatHubScreen";
import LearnScreen from "./LearnScreen";
import ArticleDetailScreen from "./chat/ArticleDetailScreen";
import MedicationsScreen from "./chat/MedicationsScreen";
import MedicationDetailScreen from "./chat/MedicationDetailScreen";
import ConditionsScreen from "./chat/ConditionsScreen";
import ConditionDetailScreen from "./chat/ConditionDetailScreen";
import TestsScreen from "./chat/TestsScreen";
import TestDetailScreen from "./chat/TestDetailScreen";
import ProceduresScreen from "./chat/ProceduresScreen";
import ProcedureDetailScreen from "./chat/ProcedureDetailScreen";

const Stack = createNativeStackNavigator<ChatStackParamList>();

type Props = {
  initialRouteName?: keyof ChatStackParamList;
};

export default function ChatNavigator({ initialRouteName = "Learn" }: Props) {
  return (
    <Stack.Navigator
      initialRouteName={initialRouteName}
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen name="Assistant" component={ChatHubScreen} />
      <Stack.Screen name="Learn" component={LearnScreen} />
      <Stack.Screen name="ArticleDetail" component={ArticleDetailScreen} />
      <Stack.Screen name="Medications" component={MedicationsScreen} />
      <Stack.Screen
        name="MedicationDetail"
        component={MedicationDetailScreen}
      />
      <Stack.Screen name="Conditions" component={ConditionsScreen} />
      <Stack.Screen name="ConditionDetail" component={ConditionDetailScreen} />
      <Stack.Screen name="Tests" component={TestsScreen} />
      <Stack.Screen name="TestDetail" component={TestDetailScreen} />
      <Stack.Screen name="Procedures" component={ProceduresScreen} />
      <Stack.Screen name="ProcedureDetail" component={ProcedureDetailScreen} />
    </Stack.Navigator>
  );
}
